<p-toast position="top-center" key="errors"></p-toast>
<ng-container>
    <app-chat-main class="h-full"></app-chat-main>
</ng-container>